import { COLOR } from '@src/styles/color';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import PauseRoundedIcon from '@mui/icons-material/PauseRounded';
import React, { useState } from 'react';
import AvatarNotFoundImg from '@src/assets/images/avatar-not-found.png';
import {
  StyledFrame,
  StyledFrameImg,
  StyledOverlayBox,
  StyledSkeletonFrameImg,
  StyledVoiceImg,
} from '../index.style';

const Frame = ({ voice, isPlaying, onPlayAudio, onPauseAudio, isLoading }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = (e) => {
    e.stopPropagation();
    if (!voice?.code) return;
    // eslint-disable-next-line no-unused-expressions
    isPlaying ? onPauseAudio() : onPlayAudio(voice);
  };

  return (
    <StyledFrame>
      {!isLoading && (
        <StyledFrameImg
          src={voice?.badge?.imageUrl}
          alt={voice?.name}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={handleClick}
          cursor={voice?.code ? 'pointer' : 'default'}
        />
      )}
      {isLoading && (
        <StyledSkeletonFrameImg
          style={{ borderRadius: '500px' }}
          animation="wave"
          variant="circular"
          width={130}
          height={130}
        />
      )}
      {voice?.roundImage && !isLoading && (
        <StyledVoiceImg src={voice?.roundImage} alt={voice?.name} />
      )}
      {!voice?.roundImage && !isLoading && (
        <StyledVoiceImg src={AvatarNotFoundImg} alt="not found" />
      )}
      {(isHovered || isPlaying) && !isLoading && voice?.code && (
        <StyledOverlayBox role="button" tabIndex={0}>
          {isPlaying ? (
            <PauseRoundedIcon
              sx={{ color: COLOR.yellow.default, fontSize: 64 }}
            />
          ) : (
            <PlayArrowRoundedIcon
              sx={{ color: COLOR.yellow.default, fontSize: 64 }}
            />
          )}
        </StyledOverlayBox>
      )}
    </StyledFrame>
  );
};

export default Frame;
